import React from 'react';
import WelcomeComponent from '../../components/WelcomeComponent/WelcomeComponent';

const WelcomePage = () => {
  return (
    <div >
      <WelcomeComponent />
    </div>
  );
};

export default WelcomePage;
